import { SVGProps } from 'react'

export const AudioIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_3580_5046)">
      <mask
        id="mask0_3580_5046"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="7"
        y="0"
        width="35"
        height="49"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.6203 0.120929C28.1076 0.291186 28.5332 0.629713 28.8353 1.08728C29.1375 1.54484 29.3004 2.09758 29.3004 2.6651V15.9993H38.9004C39.3394 15.9991 39.77 16.1327 40.1454 16.3856C40.5209 16.6384 40.8267 17.0008 41.0296 17.4334C41.2325 17.866 41.3248 18.3521 41.2964 18.8389C41.2679 19.3257 41.1199 19.7945 40.8684 20.1943L24.0683 46.8627C23.776 47.3282 23.3575 47.6779 22.874 47.8608C22.3904 48.0438 21.8669 48.0506 21.3796 47.8801C20.8924 47.7096 20.4668 47.3708 20.1647 46.913C19.8627 46.4552 19.7 45.9023 19.7003 45.3346V32.0004H10.1003C9.66134 32.0006 9.2307 31.867 8.85527 31.6142C8.47984 31.3613 8.17402 30.9989 7.97109 30.5663C7.76816 30.1338 7.67589 29.6476 7.70432 29.1608C7.73275 28.674 7.8808 28.2052 8.13235 27.8055L24.9323 1.137C25.2252 0.672397 25.6437 0.323642 26.1271 0.1414C26.6105 -0.0408428 27.1336 -0.0470795 27.6203 0.123596V0.120929Z"
          fill="#006FFD"
        />
      </mask>
      <g mask="url(#mask0_3580_5046)">
        <rect x="0.500061" width="48" height="48" fill="#FB3C3C" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3580_5046">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0.500061)"
        />
      </clipPath>
    </defs>
  </svg>
)
